import React, {useEffect, useState} from "react";
import { MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBView, MDBMask, MDBContainer } from
        "mdbreact";

const CarouselPage = (props) => {

    const [imageUrls, setImageUrls] = useState(props.urls);

    useEffect(() => {
        setImageUrls(props.urls);
    }, [props])
    return (
        <MDBContainer className="mt-3">
            <MDBCarousel
                activeItem={1}
                length={imageUrls&&imageUrls.length}
                showControls={true}
                showIndicators={true}
                className="z-depth-1"
            >
                <MDBCarouselInner>
                    {imageUrls&&imageUrls.map((imageUrl, index) => (
                        <MDBCarouselItem itemId={index+1}>
                            <MDBView>
                                <img
                                    style={{ height:"20rem"}}
                                    className="d-block w-100"
                                    src={imageUrl}
                                    alt="image"
                                />
                                <MDBMask overlay="black-light" />
                            </MDBView>
                        </MDBCarouselItem>
                    ))}
                </MDBCarouselInner>
            </MDBCarousel>
        </MDBContainer>
    );
}

export default CarouselPage;